module.exports = __webpack_public_path__ + "img/blzczz.dbb06e59.png";